import axiosInstance from "../../axios/index";
import { alertSuccess } from "../../utils/feedback";
import {
  SET_INVITATION,
  CLOSE_INVITATION,
  CHECK_INVITATION_STATUS,
  SET_INVITATION_DATA,
} from "../types/confirmInvitationTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { logout } from "./userActionCreators";

export const setOpenInvitationModal = (enterpriseId) => ({
  type: SET_INVITATION,
  payload: enterpriseId,
});

export const closeInvitation = () => ({
  type: CLOSE_INVITATION,
});

export const setInvitationStatus = (status) => ({
  type: CHECK_INVITATION_STATUS,
  payload: status,
});

export const setRegisterData = (data) => ({
  type: SET_INVITATION_DATA,
  payload: data,
});

export const checkInvitationStatus = (enterpriseId) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(
        `/auth/associate_invitation_status?account_uid=${enterpriseId}`
      );
      dispatch(requestSucceeded());
      const items = res.data;
      dispatch(setInvitationStatus(items));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestResponseInvitation = (
  enterpriseId,
  enterprise,
  response,
  history
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    const storedUser = localStorage.getItem("user");
    const publicId = JSON.parse(storedUser).public_id;
    try {
      const res = await axiosInstance.post(`/auth/associate_free_account`, {
        account_uid: enterpriseId,
        enterprise: enterprise,
        confirm: response,
      });
      dispatch(requestSucceeded());
      if (response) {
        dispatch(logout(publicId, history, { acceptInvit: true }));
      }
      dispatch(closeInvitation());
      if (res && !response) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchRegisterData = (invitationId, history) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(
        `/auth/create_invitation_status?invitation_uid=${invitationId.toString()}`
      );
      dispatch(requestSucceeded());
      const items = res.data;
      dispatch(setRegisterData(items));
      if (items?.canceled_invitation) {
        history.push("/login");
        dispatch(
          requestFailed({
            message:
              "This invitation was canceled by the enterprise administrator",
            message_fr:
              "Cette invitation à était annulée par l'administrateur de l'entreprise",
          })
        );
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestResponseInvitationRegister = (
  {
    firstName,
    lastName,
    email,
    password,
    confirmPassword,
    phoneNumber,
    country,
    enterprise,
    interest,
  },
  checked,
  invitation_uid,
  history
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(
        `/auth/create_enterprise_user?invitation_uid=${invitation_uid}`,
        {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          confirm_password: confirmPassword,
          phone: phoneNumber,
          country: country,
          entreprise: enterprise,
          check: checked,
        }
      );
      dispatch(requestSucceeded());
      history.push("/login");
      if (res) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
